"use client";
import { motion } from "motion/react";
import { useEffect, useRef } from "react";

import { cn } from "@/utils/cn";

interface SlideProps {
  className?: string;
  children: React.ReactNode;
  duration?: number;
}

function Slide({ className, children, duration = 5 }: SlideProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const slideRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (wrapperRef.current && slideRef.current) {
      wrapperRef.current.style.height = `${slideRef.current.clientHeight}px`;
    }
  }, []);

  return (
    <div ref={wrapperRef} className="relative w-full overflow-hidden">
      <motion.div
        ref={slideRef}
        initial={{ x: "0%" }}
        animate={{ x: "-50%" }}
        transition={{
          duration,
          repeat: Infinity,
          repeatType: "loop",
          ease: "linear",
        }}
        className={cn("absolute left-0 top-0 flex", className)}
      >
        {children}
        {children}
      </motion.div>
    </div>
  );
}

export default Slide;
